import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { wsGetAll } from 'services/WService.js';
import { onlyInteger } from 'hooks/Pipe';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { wsFindBy } from 'services/WService';

export default function ModalRule(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);
  
  useEffect(() => {
    if (props.model?.open) {
      setDataChanging(props.model);
    }
  }, [props.model]);



  return (
    <>
      <Modal
        title={`Actualizar registro`}
        model={ cuota }
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        entity='sale/mecanica-venta'
        dataForce={{
          type: dataChanging.type,
          state: dataChanging.state,
          base_bureau_id: dataChanging.base_bureau_id,
        }}
      >
        <TextField
          label="Descripción"
          fullWidth
          name="mecanica"
          margin="normal"
          defaultValue={dataChanging.mecanica || ''}
        />
        <TextField
          label="Fecha de corte"
          fullWidth
          type="date"
          name="fec_corte"
          margin="normal"
          defaultValue={dataChanging.fec_corte || ''}
          InputLabelProps={{
            shrink: true
          }}
          required
        />
      </Modal>
    </>
  );
}
